/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespAppliedFilters_viewer$ref: FragmentReference;
export type SbRespAppliedFilters_viewer = {|
  +isSbSharedRefineMenuSearchWithinEnabled: ?boolean,
  +$refType: SbRespAppliedFilters_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespAppliedFilters_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSbSharedRefineMenuSearchWithinEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '70924dcc8b3642193b05af64f4d73c89';
module.exports = node;
